import { toast } from 'react-toastify'
import { all, put, takeLatest } from 'redux-saga/effects'

import { uploadAvatarSuccess } from './actions'

function* uploadImage({ file }) {
  if (file.url) {
    return yield put(uploadAvatarSuccess(file))
  }

  return toast.error('verifique sua internet e envie a imagem novamente')
}

export default all([takeLatest('@cycle/UPLOAD_AVATAR_REQUEST', uploadImage)])
